import { Check, Sparkles } from "lucide-react";
import useSiteSettings from "@/hooks/useSiteSettings";

export default function Packages({ onSelect }) {
  const { settings } = useSiteSettings();
  const packages = settings.packages;

  return (
    <section
      id="packages"
      data-testid="packages-section"
      className="relative py-20 lg:py-28 px-6 lg:px-12 bg-[#F5EBD9]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-14 text-center max-w-2xl mx-auto">
          <div className="font-hand text-2xl text-[#A67F4E] mb-2">pick one!</div>
          <h2
            data-testid="packages-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#3D2E1C] leading-[1.05]"
          >
            Three packages.
            <br />
            <span className="text-[#A67F4E]">One clean ride.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-7">
          {packages.map((pkg) => {
            const accent = pkg.id === "premium";
            return (
              <div
                key={pkg.id}
                data-testid={`package-card-${pkg.id}`}
                className={`relative group flex flex-col p-8 rounded-3xl border-2 transition-all duration-500 hover:-translate-y-2 ${
                  accent
                    ? "bg-[#3D2E1C] border-[#3D2E1C] text-[#FDF9F3]"
                    : "bg-white border-[#E9DFCB] hover:border-[#D6B98D]"
                }`}
              >
                {accent && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 px-4 py-1.5 bg-[#D6B98D] text-[#3D2E1C] text-xs font-bold rounded-full">
                    <Sparkles className="w-3 h-3" strokeWidth={2.5} /> Most popular
                  </div>
                )}

                <div className={`text-xs font-bold uppercase tracking-wider mb-3 ${accent ? "text-[#D6B98D]" : "text-[#A67F4E]"}`}>
                  {pkg.tagline}
                </div>
                <h3 className={`font-serif text-4xl font-bold mb-2 ${accent ? "text-[#FDF9F3]" : "text-[#3D2E1C]"}`}>
                  {pkg.name}
                </h3>
                <div className="flex items-baseline gap-1 mb-8">
                  <span className={`text-5xl font-serif font-bold ${accent ? "text-[#D6B98D]" : "text-[#3D2E1C]"}`}>
                    ${Number(pkg.price).toFixed(0)}
                  </span>
                  <span className={`text-sm ${accent ? "text-[#FDF9F3]/60" : "text-[#7A6A55]"}`}>
                    / session
                  </span>
                </div>

                <ul className="space-y-3 mb-8 flex-1">
                  {(pkg.features || []).map((f, i) => (
                    <li key={i} className={`flex items-start gap-3 text-sm font-medium ${accent ? "text-[#FDF9F3]/90" : "text-[#3D2E1C]/80"}`}>
                      <Check
                        className={`w-4 h-4 mt-0.5 flex-shrink-0 ${accent ? "text-[#D6B98D]" : "text-[#A67F4E]"}`}
                        strokeWidth={3}
                      />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => onSelect(pkg.id)}
                  data-testid={`select-package-${pkg.id}`}
                  className={`w-full py-3.5 text-sm font-bold rounded-full transition-all duration-300 ${
                    accent
                      ? "bg-[#D6B98D] text-[#3D2E1C] hover:bg-[#FDF9F3]"
                      : "bg-[#3D2E1C] text-[#FDF9F3] hover:bg-[#A67F4E]"
                  }`}
                >
                  Pick {pkg.name} →
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
